import { Item } from 'baseui/side-navigation';
import { Key } from 'react';
import { useRecoilValue } from 'recoil';
import {
  CHILDREN_EMISSIONS_PAGE_IDS,
  CHILDREN_EQUIPMENT_PAGE_IDS,
  CHILDREN_FLEET_HEALTH_PAGE_IDS,
  CHILDREN_PLATFORM_PAGE_IDS,
  CHILDREN_REPORTS_PANELS_PAGE_IDS,
  CHILDREN_VEHICLE_PAGE_IDS,
  EMISSIONS_PAGE_ID,
  EMISSIONS_PAGE_IDS,
  EQUIPMENT_PAGE_ID,
  EQUIPMENT_PAGE_IDS,
  FLEET_HEALTH_PAGE_ID,
  FLEET_HEALTH_PAGE_IDS,
  PLATFORM_PAGE_ID,
  PLATFORM_PAGE_IDS,
  REPORTS_PANELS_PAGE_ID,
  REPORTS_PANELS_PAGE_IDS,
  VEHICLE_PAGE_ID,
  VEHICLE_PAGE_IDS,
} from '../constants/app';
import { pageState } from '../storage/app';
import { SidenavBlock } from '../types/app';

export function useSidenavItems(items: Item[]) {
  const currentPage = useRecoilValue(pageState);

  const platformItems = items.filter((item) => item.itemId && PLATFORM_PAGE_IDS.includes(item.itemId));
  const emissionsItems = items.filter((item) => item.itemId && EMISSIONS_PAGE_IDS.includes(item.itemId));
  const equimentItems = items.filter((item) => item.itemId && EQUIPMENT_PAGE_IDS.includes(item.itemId));
  const vehicleItems = items.filter((item) => item.itemId && VEHICLE_PAGE_IDS.includes(item.itemId));
  const reportsItems = items.filter((item) => item.itemId && REPORTS_PANELS_PAGE_IDS.includes(item.itemId));
  const fleetHealthItems = items.filter((item) => item.itemId && FLEET_HEALTH_PAGE_IDS.includes(item.itemId));

  const pageSection: Key | undefined = (() => {
    if (PLATFORM_PAGE_IDS.includes(currentPage) || CHILDREN_PLATFORM_PAGE_IDS.includes(currentPage)) {
      return PLATFORM_PAGE_ID;
    }
    if (EMISSIONS_PAGE_IDS.includes(currentPage) || CHILDREN_EMISSIONS_PAGE_IDS.includes(currentPage)) {
      return EMISSIONS_PAGE_ID;
    }
    if (EQUIPMENT_PAGE_IDS.includes(currentPage) || CHILDREN_EQUIPMENT_PAGE_IDS.includes(currentPage)) {
      return EQUIPMENT_PAGE_ID;
    }
    if (VEHICLE_PAGE_IDS.includes(currentPage) || CHILDREN_VEHICLE_PAGE_IDS.includes(currentPage)) {
      return VEHICLE_PAGE_ID;
    }
    if (REPORTS_PANELS_PAGE_IDS.includes(currentPage) || CHILDREN_REPORTS_PANELS_PAGE_IDS.includes(currentPage)) {
      return REPORTS_PANELS_PAGE_ID;
    }
    if (FLEET_HEALTH_PAGE_IDS.includes(currentPage) || CHILDREN_FLEET_HEALTH_PAGE_IDS.includes(currentPage)) {
      return FLEET_HEALTH_PAGE_ID;
    }
  })();

  const navigationBlocks: SidenavBlock[] = [
    {
      type: 'section',
      id: PLATFORM_PAGE_ID,
      title: 'Plataforma',
      items: platformItems,
    },
    {
      type: 'section',
      id: EMISSIONS_PAGE_ID,
      title: 'Instalaciones',
      items: emissionsItems,
    },
    {
      type: 'section',
      id: FLEET_HEALTH_PAGE_ID,
      title: 'Salud de Flota',
      items: fleetHealthItems,
    },
    {
      type: 'section',
      id: VEHICLE_PAGE_ID,
      title: 'Vehículos',
      items: vehicleItems,
    },
    {
      type: 'section',
      id: EQUIPMENT_PAGE_ID,
      title: 'Equipos',
      items: equimentItems,
    },
    {
      type: 'section',
      id: REPORTS_PANELS_PAGE_ID,
      title: 'Reportes',
      items: reportsItems,
    },
  ];

  return {
    pageSection,
    navigationBlocks: navigationBlocks.filter((block) => block.items.length > 0),
  };
}
